import { Component, type ErrorInfo, type ReactNode } from 'react';
import StatusScreen, { StatusPrimaryButton } from '../components/layout/StatusScreen';
import { trackException } from './index';
import { ExceptionProp } from './events';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

export class ObservabilityErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        trackException(error, { [ExceptionProp.ComponentStack]: errorInfo.componentStack ?? '' });
    }

    render() {
        if (this.state.hasError) {
            return (
                <StatusScreen
                    iconBg="#fee2e2"
                    iconColor="#dc2626"
                    icon={<span>!</span>}
                    title="Something went wrong"
                    subtitle="An unexpected error occurred. Please refresh the page — if this keeps happening, contact support."
                    actions={
                        <StatusPrimaryButton full onClick={() => window.location.reload()}>
                            Reload
                        </StatusPrimaryButton>
                    }
                />
            );
        }
        return this.props.children;
    }
}
